import type { SearchTourStep } from './searchTourSteps';

export const STICKY_NOTES_TOUR_STEPS: SearchTourStep[] = [
  {
    id: 'toggle',
    title: 'Open Sticky Notes',
    body: 'Use the floating sticky icon (usually bottom-right) to open the notes menu from any page.',
    selector: '[data-demo-tour="sticky-notes-toggle"]',
    fallbackSelector: 'button[aria-label="Sticky notes"]',
  },
  {
    id: 'privacy',
    title: 'Private to this device',
    body: 'Notes stay in your browser’s local storage. They are not uploaded to DISGENET databases.',
    selector: '[data-demo-tour="sticky-notes-privacy"]',
    fallbackSelector: '[data-demo-tour="sticky-notes-palette"]',
    prepare: ['sticky-open-palette'],
  },
  {
    id: 'colors',
    title: 'Pick a color to create',
    body: 'Choose a color swatch under “New note”. Each color helps you organize topics at a glance.',
    selector: '[data-demo-tour="sticky-notes-swatch"]',
    fallbackSelector: '[data-demo-tour="sticky-notes-colors"]',
    prepare: ['sticky-open-palette'],
  },
  {
    id: 'write',
    title: 'Write your note',
    body: 'Click inside the note and type freely. Text is saved automatically as you write (after a short pause).',
    selector: '[data-demo-tour="sticky-note-textarea"]',
    fallbackSelector: '[data-demo-tour="sticky-note"]',
    prepare: ['sticky-ensure-open-note'],
  },
  {
    id: 'drag',
    title: 'Move the note',
    body: 'Drag the top bar (⋮⋮) to place the note next to the evidence or UI you are reviewing.',
    selector: '[data-demo-tour="sticky-note-header"]',
    fallbackSelector: '[data-demo-tour="sticky-note"]',
    prepare: ['sticky-ensure-open-note'],
  },
  {
    id: 'resize',
    title: 'Resize the note',
    body: 'Drag the bottom-right corner handle to make the note larger or smaller for longer comments.',
    selector: '[data-demo-tour="sticky-note-resize"]',
    fallbackSelector: '[data-demo-tour="sticky-note"]',
    prepare: ['sticky-ensure-open-note'],
  },
  {
    id: 'minimize',
    title: 'Minimize to save space',
    body: 'Use “−” to minimize. The note leaves the screen but stays in your Saved notes list.',
    selector: '[data-demo-tour="sticky-note-minimize"]',
    fallbackSelector: '[data-demo-tour="sticky-note"]',
    prepare: ['sticky-ensure-open-note'],
  },
  {
    id: 'restore',
    title: 'Restore a saved note',
    body: 'Open the menu again and click a saved note preview to bring it back onto the page.',
    selector: '[data-demo-tour="sticky-notes-restore"]',
    fallbackSelector: '[data-demo-tour="sticky-notes-saved"]',
    prepare: ['sticky-prepare-restore'],
    note: 'If the list is empty, minimize a note first — the tour tries to do that for you.',
  },
  {
    id: 'profile',
    title: 'Manage all notes in Profile',
    body: 'In Profile → Sticky Notes you can search, filter by color, edit, and delete every note stored on this device.',
    selector: '[data-demo-tour="sticky-notes-toggle"]',
    tipPlacement: 'corner',
    note: 'Open Profile area → Sticky Notes anytime to manage your full list.',
  },
];
